import { createPortal } from 'react-dom';
import { StoryblokImage } from '../../base/StoryblokImage/StoryblokImage';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Box } from '../../base/Box/Box';

// We want the height to match the height of the first "cluster" of components
// that share the same background color, plus the height of the header itself
const getElementHeight = (colourScheme) => {
  const main = document.getElementsByTagName('main')[0];
  const header = document.getElementsByTagName('header')[0]
    .firstChild as HTMLElement;
  let elements: HTMLElement[] = [];
  let limitReached = false;

  Array.from(main.children).forEach((element) => {
    if (element.className.includes(`ff-${colourScheme}`) && !limitReached) {
      elements.push(element as HTMLElement);
    } else {
      limitReached = true;
    }
  });

  return elements
    .map((element) => element.offsetHeight)
    .reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      header.offsetHeight
    );
};

export const BackgroundImage = ({
  image,
  isMobile = false,
  colourScheme,
}: any) => {
  const [target, setTarget] = useState(null);
  const [elementHeight, setElementHeight] = useState(0);

  useEffect(() => {
    if (!target) {
      setTarget(document.getElementsByTagName('header')[0]);
      setElementHeight(getElementHeight(colourScheme));
      window.addEventListener('resize', () =>
        setElementHeight(getElementHeight(colourScheme))
      );
    }
  }, [colourScheme]);

  if (!target) {
    return null;
  }

  return createPortal(
    <Box
      as="div"
      className={classNames(
        isMobile ? 'block md:hidden' : 'hidden md:block',
        'z-1 absolute left-0 top-0 flex w-full overflow-hidden'
      )}
      style={{ height: `${elementHeight}px` }}
    >
      <StoryblokImage
        src={image}
        maxWidth={3600}
        alt={'Header Hero Section Background Image'}
        mode={'cover'}
        wrapperClassName={'h-full w-full'}
      />
    </Box>,
    target
  );
};
